import { createSlice } from '@reduxjs/toolkit';
import { createAppThunk } from '../createAppThunk';
import { fetchStressLevels } from '@/services/stressTestService';
import { toAppError } from '@/lib/toAppError';

interface StressLevelState {
  labels: string[];
  data: number[];
}

const initialState: StressLevelState = {
  labels: [],
  data: [],
};

export const fetchStressLevelData = createAppThunk<
  { data: number[]; labels: string[]; totalQuestions: number },
  { userId: string; token: string }
>('stressLevel/fetchStressLevelData', async ({ userId, token }, { getState, rejectWithValue }) => {
  const state = getState();

  if (!token) return rejectWithValue(toAppError(new Error('No auth token available')));
  const totalQuestions = state.questionnaire.questions.length;

  if (!userId) return rejectWithValue(toAppError(new Error('User ID is not available')));

  const response = await fetchStressLevels(userId, token);

  return { data: response.data, labels: response.labels, totalQuestions };
});

const stressLevelSlice = createSlice({
  name: 'stressLevel',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchStressLevelData.fulfilled, (state, action) => {
      const { data, labels, totalQuestions } = action.payload;

      if (data.length === 0) {
        const halfScore = totalQuestions / 2;
        state.labels = ['0', '0'];
        state.data = [halfScore, halfScore];
      } else if (data.length === 1) {
        state.labels = [labels[0], labels[0]];
        state.data = [data[0], data[0]];
      } else {
        state.labels = labels;
        state.data = data;
      }
    });
  },
});

export default stressLevelSlice.reducer;
